import { type Dispatch, type SetStateAction, type MutableRefObject } from 'react';

import { getDwelledOnPage } from 'dibs-buyer-layout/exports/dwelledOnPage';

import { canDisplayFavoritesNudge } from './canDisplayFavoritesNudge';
import { setFavoritesNudgeDisplayed } from './setFavoritesNudgeDisplayed';
import { updateFavoritesNudgeDisplayedCount } from './updateFavoritesNudgeDisplayedCount';
import { getFavoritesNudgeDisplayedCount } from './getFavoritesNudgeDisplayedCount';

import { FIRST_FAVORITES_NUDGE_DELAY_MS } from '../constants';

function scheduleNudgeDisplay(
    mountedRef: MutableRefObject<boolean>,
    setIsVisible: Dispatch<SetStateAction<boolean>>
): (() => void) | null {
    const favoritesNudgeDisplayedCount = getFavoritesNudgeDisplayedCount();

    function showNudge(): void {
        setIsVisible(true);
        setFavoritesNudgeDisplayed();
        updateFavoritesNudgeDisplayedCount();
    }

    if (favoritesNudgeDisplayedCount >= 1) {
        const intervalId = window.setInterval(() => {
            if (!canDisplayFavoritesNudge() || !mountedRef.current) {
                window.clearInterval(intervalId);
            } else if (getDwelledOnPage('search') || getDwelledOnPage('pdp')) {
                showNudge();
                window.clearInterval(intervalId);
            }
        }, 1000);

        return () => window.clearInterval(intervalId);
    }

    if (mountedRef.current) {
        const timeoutId = window.setTimeout(() => {
            if (mountedRef.current) {
                showNudge();
            }
        }, FIRST_FAVORITES_NUDGE_DELAY_MS);

        return () => window.clearTimeout(timeoutId);
    }

    return null;
}

export { scheduleNudgeDisplay };
